// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1PVEr","footer":"ModalInfo_footer__5y3ty"};